<div *ngIf="value != null" class="container">
    <div class="block-title">
        <div class="title"> {{ 'SHARED.EXTERNAL.CMR.ACTIONS.TRANSFERTOANOTHERDRIVER.CAPTION' | translate }} </div>
    </div>

    <shared-cmr-qr-component *ngIf="!showChangeDriverDataInfo" [agent]="'driver'" [uuidQR]="value.uuidQR"></shared-cmr-qr-component>

    <shared-external-driverplate-component class="qrcmr" [uuid]="value.uuidExwork" [data]="driverInfo" (changeEditMode)="onChangeEditMode($event)" (refreshData)="onRefreshData()"></shared-external-driverplate-component>
</div>